const dev = {
  API_ENDPOINT_URL: 'https://sab.expresswebs.ca/slim',
  WS_ENDPOINT_URL: 'wss://app.expresswebs.ca/ws/'
};

const prod = {
  API_ENDPOINT_URL: 'https://sab.expresswebs.ca/slim',
  WS_ENDPOINT_URL: 'wss://app.expresswebs.ca/ws/'
};

const test = {
  API_ENDPOINT_URL: '/api',
//   WS_ENDPOINT_URL: 'wss://app.expresswebs.ca/ws/'
};


const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
